module.exports = __webpack_public_path__ + "static/Icons_homeloans_Inactive_small-aecae3d89e5492c722727ae41d9e4e5f.png";